import { attribute, autoGeneratedHashKey } from '@awslabs-community-fork/dynamodb-data-mapper-annotations';
import { dynamicTableName } from '@pristine-ts/aws';
import { EventTypeEnum } from '../enums/event-type.enum';
import { UserPublicInfoInterface } from '../interfaces/user-public-info.interface';
import { property } from '@pristine-ts/metadata';

@dynamicTableName('EVENT_TABLE_NAME')
export class EventModel<T> {
  @autoGeneratedHashKey()
  @property()
  id: string;
  @attribute()
  @property()
  organizationId: string;
  @attribute()
  @property()
  eventType: EventTypeEnum;
  @attribute()
  @property()
  userInfo?: UserPublicInfoInterface;
  @attribute()
  @property()
  createdAt: Date;
  @attribute()
  @property()
  payload: T;
}
